$(document).on('turbo:load', function() {
  $('.header-menu-mobile').click(function() {
    $(this).toggleClass('header-transition');
    $(".header-menu-user, .header-menu-user-info, .header-menu-search").slideToggle();
  });
});
